var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsericon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 96,
    viewBox: "0 0 94 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.6875 54C77.5625 54 89 65.4375 89 79.3125V87C89 92.0625 84.875 96 80 96H14C8.9375 96 5 92.0625 5 87V79.3125C5 65.4375 16.25 54 30.125 54C35.5625 54 38 57 47 57C55.8125 57 58.25 54 63.6875 54ZM83 87V79.3125C83 68.625 74.375 60 63.6875 60C60.125 60 56.375 63 47 63C37.4375 63 33.875 60 30.125 60C19.4375 60 11 68.625 11 79.3125V87C11 88.6875 12.3125 90 14 90H80C81.5 90 83 88.6875 83 87ZM47 48C33.6875 48 23 37.3125 23 24C23 10.875 33.6875 0 47 0C60.125 0 71 10.875 71 24C71 37.3125 60.125 48 47 48ZM47 6C37.0625 6 29 14.25 29 24C29 33.9375 37.0625 42 47 42C56.75 42 65 33.9375 65 24C65 14.25 56.75 6 47 6Z",
    fill: "#777E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsericon);
export default __webpack_public_path__ + "static/media/usericon.beee23a4088b1930bb2aa459a1417bf7.svg";
export { ForwardRef as ReactComponent };